export const getIsPosting = state => state.getIn(['exportConsultations', 'isPosting']);
export const getErrMsg = state => state.getIn(['exportConsultations', 'errMsg']);

export const getCaseRelateList = state => state.getIn(['exportConsultations', 'caseRelateList']);
export const getIsFetching = state => state.getIn(['exportConsultations', 'isFetching']);